<template>
  <ion-card @click="openModal">
    <ion-card-content>
      <span class="review"> "{{ review?.description }}" </span>
      <ion-row class="justify-content-between">
        <div class="author">
          {{ review?.user?.profile?.nickName }} 
        </div>
        <div class="rate">
          <ion-icon
            :icon="star"
            v-for="n in Math.round(review?.rating)"
            class="yellow-star"
            :key="n"
          />
          <ion-icon
            :icon="starOutline"
            v-for="n in Math.round(5 - review?.rating)"
            class="black-star"
            :key="n"
          />
          <span>({{ review?.rating }})</span>
        </div>
      </ion-row>
      <div class="float-right">
        {{
          new Date(review?.updatedAt).toLocaleDateString("en-GB", {
            day: "numeric",
            month: "short",
            year: "numeric",
          })
        }}
      </div>
    </ion-card-content>
  </ion-card>
</template>

<script setup lang="ts">
import { defineProps } from "vue";
import { IonCard, IonCardContent, IonIcon, IonRow, modalController } from "@ionic/vue";
import { star, starOutline } from "ionicons/icons";
import ReviewDetailModal from "../Modal/ReviewDetailModal.vue";

const props = defineProps({ review: Object });

const openModal = async () => {
  
  const modal = await modalController.create({
    component: ReviewDetailModal,
    cssClass: "review-modal",
    componentProps: {
      review: props.review,
    },
  });
  modal.present();
};
</script>

<style lang="scss" scoped>
@import "../../theme/variables/_color.scss";
@import "../../theme/variables/_typography.scss";

ion-card {
  width: 100%;
  margin: 0px;
  background: $grey20;
  border-radius: 10px;

  & ion-card-content {
    padding: 14px 20px 6px 20px;

    & .review {
      @include text-14-normal;
      line-height: 26px;
      // padding-bottom: 10px;
    }

    & ion-row {
      margin-top: 10px;

      & .author {
        @include text-16-bold;
        color: $primary-black;
        text-transform: capitalize;
      }
    }

    & .rate {
      display: flex;
      align-items: center;
      gap: 3px;

      & ion-icon {
        &.yellow-star {
          color: $primary-yellow;
        }
        &.black-star {
          color: #222;
        }
      }

      & span {
        @include normal;
        align-self: center;
        font-size: 10px;
        color: $secondary-black;
      }
    }

    .float-right {
      text-align: end;
      @include text-10-bold;
      line-height: 26px;
      color: $secondary-black;
    }
  }
}
.in-list:nth-child(even) {
  .md {
    background: #fff6f6;
  }
}
</style>
